import { useEffect, useState } from "react";


export const GeneralModal = ({ isModalOpen, onModalClose, children }) => {
    const [visible, setVisible] = useState(isModalOpen);
  
    useEffect(() => {
      setVisible(isModalOpen);
    }, [isModalOpen]);
  
    if (!visible) {
      return null;
    }
  
    return (
      <div className="fixed inset-0 flex items-center justify-center z-50">
        <div
          className="absolute inset-0 bg-black opacity-50 z-10"
          onClick={onModalClose}
        ></div>
        <div
          className="z-20
        "
        >
          <div
            className=" bg-[#4706FF] p-6 w-96 animate-popin
            border-dashed border-[4px] border-white
            transition-all duration-500 ease-in-out
  
            "
          >
            {" "}
            <div className="flex justify-between items-center">
              {children}
            </div>
          </div>
        </div>
      </div>
    );
  };